import _ from 'lodash';
export class CharacteristicFilter {
    characteristicName
    filterType = 'characteristic'
    constructor(characteristicName) {
        this.characteristicName = characteristicName
    }

    apply(products) {
        if (this.characteristicName.length > 0) {
            const productsAux = _.cloneDeep(products)
            const productsAux2 = []
            for (let i = 0; i < productsAux.length; i++) {
                const product = productsAux[i];
                const characteristics = product.Caracteristicas.split(' | ')
                const characteristicsAux = this.trimStrings(characteristics)
                const characteristNumberEquals = _.intersection(characteristicsAux, this.characteristicName).length
                if (characteristNumberEquals === this.characteristicName.length) {
                    productsAux2.push(product)
                }
            }
            return productsAux2
        } else {
            return products
        }
    }

    trimStrings(characteristics) {
        const characteristicsAux = []
        for (let i = 0; i < characteristics.length; i++) {
            const characteristic = characteristics[i];
            characteristicsAux.push(characteristic.trim())
        }
        return characteristicsAux
    }
}